// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"377":"chat","545":"language","822":"disclaimer"}[chunkId] + "." + {"377":"3a929bd4","545":"02a28a84","822":"0670fffb"}[chunkId] + ".js";
};